import { render, staticRenderFns } from "./importResult.vue?vue&type=template&id=d1966858&"
import script from "./importResult.vue?vue&type=script&lang=js&"
export * from "./importResult.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports